import QuestionCard from '../ConceptQuestActivity/QuestionCard/QuestionCard';
import { StyledTrainingActivity } from './TrainingActivity.styled';
import useTrainingActivity from './useTrainingActivity.hook';

export default function TrainingActivity({
  activity,
  initialTaskProgress,
  taskProgressAPI,
  onFinishedActivity,
}) {
  const { state, actions } = useTrainingActivity({
    activity,
    initialTaskProgress,
    taskProgressAPI,
    onFinishedActivity,
  });

  const folder = activity?.data?.folder;
  const questions = activity?.data?.questions;

  return (
    <StyledTrainingActivity>
      {state.finished ? (
        <div className="finish-screen">
          <div className="title success">Congratulations!</div>
          <div className="subtitle">
            You've successfully completed the training
          </div>
        </div>
      ) : (
        <div className="questions">
          {questions?.map((question) => (
            <QuestionCard
              className={
                state.questionIdsListened.includes(question.id)
                  ? 'listened'
                  : ''
              }
              key={question.id}
              question={question}
              folder={folder}
              disabled={
                state.questionPlaying && state.questionPlaying.id != question.id
              }
              onAudioPlaying={() => actions.onQuestionPlaying(question)}
              onAudioEnded={() => actions.onQuestionListened(question)}
            />
          ))}
        </div>
      )}
    </StyledTrainingActivity>
  );
}
